import clsx from "clsx";
import { MultiSelect as PrimeMultiSelect } from "primereact/multiselect";
import PropTypes from "prop-types";
import React from "react";
import classes from "./MultiSelectDropdown.module.css";
const MultiSelectDropdown = ({
  value,
  onChange,
  options,
  placeholder,
  className,
  errorText,
  disabled,
  id,
  label,
  isOptional,
  icon, // New prop for the icon
  filter = false,
  filterPlaceholder = "Search",
  emptyFilterMessage = "No results found",
  ...rest
}) => {
  console.log("Options", options);
  // Custom template for the selected value with an icon
  const itemTemplate = (option) => (
    <div className={classes.optionItem}>
      {option.icon ? (
        <span className={classes.optionIcon}>{option.icon}</span>
      ) : null}
      <span className={classes.truncateText}>{option.label}</span>
    </div>
  );

  const selectedValueTemplate = (option) => {
    return (
      <div className={classes.valueWithIcon}>
        {icon && <span className={classes.icon}>{icon}</span>}
        <span className={classes.truncateText}>
          {option ? option.label : placeholder}
        </span>
      </div>
    );
  };

  return (
    <>
      <style jsx>
        {`
          .p-dropdown {
            // width: 150px !important; /* Set a fixed width */
          }

          .p-dropdown-item {
            outline: 0 !important;
          }
        `}
      </style>

      <div className={classes.dropdownWrapper}>
        {label && (
          <label htmlFor={id} className={classes.labelText}>
            {label} {"   "}{" "}
            {!isOptional && <span className={clsx("steric")}>*</span>}
          </label>
        )}
        <PrimeMultiSelect
          id={id}
          value={value}
          onChange={(e) => onChange(e?.target?.value)}
          options={[...options]}
          placeholder={placeholder}
          className={`${classes.customDropdown} ${errorText ? classes.error : ""} ${
            className || ""
          }`}
          appendTo="self"
          disabled={disabled}
          valueTemplate={selectedValueTemplate} // Use the custom template
          itemTemplate={itemTemplate} // Renders icons inside dropdown
          filter={filter}
          filterPlaceholder={filterPlaceholder}
          emptyFilterMessage={emptyFilterMessage}
          {...rest}
        />
        {errorText && <p className={"errorText"}>{errorText}</p>}
      </div>
    </>
  );
};

MultiSelectDropdown.propTypes = {
  value: PropTypes.any,
  onChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  className: PropTypes.string,
  errorText: PropTypes.string,
  disabled: PropTypes.bool,
  icon: PropTypes.node, // New prop for the icon
  filter: PropTypes.bool,
  filterPlaceholder: PropTypes.string,
  emptyFilterMessage: PropTypes.string,
};

export default MultiSelectDropdown;
